export default __webpack_public_path__ + "static/benefit-4-c317418b08e069be5b9ad6aa3d00fab8.jpg";